import {
	CalendarFilled,
	CalendarOutlined,
	CheckCircleOutlined,
	ClockCircleOutlined,
	CoffeeOutlined,
	CreditCardOutlined,
	FieldTimeOutlined,
	FileDoneOutlined,
	FileOutlined,
	FileProtectOutlined,
	FileTextOutlined,
	FlagFilled,
	FlagOutlined,
	FolderOpenOutlined,
	HomeOutlined,
	IdcardOutlined,
	ManOutlined,
	NotificationFilled,
	PieChartOutlined,
	PlusCircleOutlined,
	PoundOutlined,
	PoweroffOutlined,
	ProfileOutlined,
	ProjectFilled,
	ProjectOutlined,
	ScheduleOutlined,
	SettingOutlined,
	SmileOutlined,
	SolutionOutlined,
	StopOutlined,
	TeamOutlined,
	TransactionOutlined,
	TrophyFilled,
	UnlockOutlined,
	UploadOutlined,
	UserDeleteOutlined,
	UserOutlined,
	UserSwitchOutlined,
	UsergroupAddOutlined,
	WalletOutlined
} from "@ant-design/icons";

import { Menu, Tooltip } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import styles from "./Sidenav.module.css";

const Sidenav = ({ color, sideNavOpenKeys }) => {
	const [isOnboardingComplete, setIsOnboardingComplete] = useState(true);
	// const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);
	const user = getUserFromToken();
	const dispatch = useDispatch();
	const { list: onboardingData } = useSelector((state) => state.setUp);
	const permissions = getPermissions();
	// console.log("pp", permissions)
	const hasPermission = (item) => {
		return permissions?.includes(item ? item : "");
	};
	// console.log("haspermission", hasPermission("create-user"));

	useEffect(() => {
		const fetchOnboardingProgress = async () => {
			try {
				const companyId = getCompanyIdFromToken();
				if (!companyId) {
					// message.error('Company ID not found in token');
					return;
				}

				const response = await axios.get(`/initialSetUp/onboarding-progress?companyId=${companyId}`);
				const allCompleted = response.data.every(step => step.completed);
				setIsOnboardingComplete(allCompleted);
			} catch (error) {
				console.error('Error fetching onboarding progress:', error);
				// message.error('Failed to fetch onboarding progress');
			}
		};

		fetchOnboardingProgress();
	}, []);

	// useEffect(() => {
	// 	const companyId = getCompanyIdFromToken();
	// 	if (!companyId) {
	// 	  return;
	// 	}
	// 	dispatch(getOnboarding(companyId));
	//   }, [dispatch]);

	//   // Update onboarding completion status when data changes
	//   useEffect(() => {
	// 	if (onboardingData) {
	// 	  const allCompleted = onboardingData.every(step => step.completed);
	// 	  setIsOnboardingComplete(allCompleted);
	// 	}
	//   }, [onboardingData]);


	const menu = [
		{
			label: (
				<NavLink to='/admin/dashboard' className={styles.menuLabel}>
					<span>Dashboard</span>
				</NavLink>
			),
			key: "dashboard",
			icon: <HomeOutlined />,
		},

		

		(isOnboardingComplete && (
			hasPermission("create-user") ||
			hasPermission("readAll-user") ||
			hasPermission("readAll-role") ||
			hasPermission("readAll-designation") ||
			hasPermission("readAll-department"))) && {
			label: (
				<span className={styles.menuLabel}>HR</span>
			),
			key: "hr",
			icon: <UserOutlined />,
			children: [
				hasPermission("create-user") && {
					label: (
						<NavLink to='/admin/hr/staffs/new' className={styles.menuLabel}>
							<span>New Employee</span>
						</NavLink>
					),

					key: "staffs",
					icon: <UsergroupAddOutlined />,
				},
				hasPermission("readAll-user") && {
					label: (
						<NavLink to='/admin/hr/staffs' className={styles.menuLabel}>
						{/* <NavLink to='/admin/hr/staffs'> */}
							<span>Employee List</span>
						</NavLink>
					),
					key: "users",
					icon: <UsergroupAddOutlined />,
				},
				hasPermission("readAll-department") &&
				{
					label: (
						<NavLink to='/admin/termination' className={styles.menuLabel}>
							<span>Termination</span>
						</NavLink>
					),
					key: "termination",
					icon: <PoweroffOutlined />,
				},
				hasPermission("readAll-department") &&
				{
					label: (
						<NavLink to='/admin/contractDetails' className={styles.menuLabel}>
							<span>Contract Details</span>
						</NavLink>
					),
					key: "contractDetails",
					icon: <SolutionOutlined />,
				},
				


				
				// hasPermission("readAll-department") && {
				// 	label: (
				// 		<NavLink to='/admin/removeBiometric' className={styles.menuLabel}>
				// 			<span>Remove Biometric</span>
				// 		</NavLink>
				// 	),
				// 	key: "Remove Biometric",
				// 	icon: <DeleteOutlined />,
				// },


			],
		},



		(isOnboardingComplete && (hasPermission("create-attendance") ||
			hasPermission("readAll-attendance"))) && {
			label: (
				<span className={styles.menuLabel}>ATTENDANCE</span>
			),
			key: "attendance",
			icon: <IdcardOutlined />,
			children: [
				hasPermission("readAll-attendance") && {
					label: (
						<NavLink to='/admin/attendance' className={styles.menuLabel}>
							<span>Attendance</span>
						</NavLink>
					),
					key: "attendance",
					icon: <ProfileOutlined />,
				},
				hasPermission("readSingle-attendance") && {
					label: (
						<NavLink to='/admin/userAttendance' className={styles.menuLabel}>
							<span>My Attendance</span>
						</NavLink>
					),
					key: "attendance",
					icon: <ProfileOutlined />,
				},
				hasPermission("readSingle-attendance") && {
					label: (
						<NavLink to={`/admin/attendance/user/${user}`} className={styles.menuLabel}>
							<span>Calendar</span>
						</NavLink>
					),
					key: "myAttendance",
					icon: <CalendarFilled />,
				},
				
			],
		},

		(isOnboardingComplete && (hasPermission("create-leaveApplication"))) && {
			label: (
				<span className={styles.menuLabel}>OVERTIME</span>
			),
			key: "OverTime",
			icon: <FieldTimeOutlined />,
			children: [
				hasPermission("readSingle-leaveApplication") && {
					label: (
						<NavLink to='/admin/overtime' className={styles.menuLabel}>
							<span>Log Overtime</span>
						</NavLink>
					),
					key: "overtime",
					icon: <FieldTimeOutlined />,
				},
				hasPermission("readAll-leaveApplication") && {
					label: (
						<NavLink to='/admin/getOvertime' className={styles.menuLabel}>
							<span>Overtime History</span>
						</NavLink>
					),
					key: "overtime",
					icon: <FieldTimeOutlined />,
				},
				
			],
		},


		(isOnboardingComplete && (hasPermission("create-payroll") || hasPermission("readAll-payroll"))) && {
			label: (
				<span className={styles.menuLabel}>PAYROLL</span>
			),
			key: "payroll",
			icon: <WalletOutlined />,
			children: [
				hasPermission("create-payroll") && {
					label: (
						<NavLink to='/admin/payroll/new' className={styles.menuLabel}>
							<span>Calculate Payroll</span>
						</NavLink>
					),
					key: "calculatePayroll",
					icon: <FileDoneOutlined />,
				},
				// incomplete component need to save data on save button
				// hasPermission("create-payroll") && {
				// 	label: (
				// 		<NavLink to='/admin/uploadPaySlip' className={styles.menuLabel}>
				// 			<span>Upload PaySlip</span>
				// 		</NavLink>
				// 	),
				// 	key: "uploadPaySlip",
				// 	icon: <UploadOutlined />,
				// },
				hasPermission("readAll-payroll") && {
					label: (
						<NavLink to='/admin/payroll/list' className={styles.menuLabel}>
							<span>Payslip List</span>
						</NavLink>
					),
					key: "payslipList",
					icon: <FileOutlined />,
				},
				
			],
		},

		// (isOnboardingComplete && (hasPermission("create-leaveApplication") ||
		// 	hasPermission("readAll-leaveApplication") ||
		// 	hasPermission("readSingle-leaveApplication"))) && {
		// 	label: (
		// 		<span className={styles.menuLabel}>MY DOCUMENTS</span>
		// 	),
		// 	key: "User Document",
		// 	icon: <UserDeleteOutlined />,
		// 	children: [
		// 		hasPermission("create-leaveApplication") && {
		// 			label: (
		// 				<NavLink to='/admin/user/documents' className={styles.menuLabel}>
		// 					<span> Upload Document </span>
		// 				</NavLink>
		// 			),
		// 			key: "UploadDocument",
		// 			icon: <PlusCircleOutlined />,
		// 		},
		// 		hasPermission("readAll-payroll") && {
		// 			label: (
		// 				<NavLink to='/admin/user/documentList' className={styles.menuLabel}>
		// 					<span>View Document</span>
		// 				</NavLink>
		// 			),
		// 			key: "View Document",
		// 			icon: <CheckCircleOutlined />,
		// 		},

		// 	],
		// },



		(isOnboardingComplete && (hasPermission("create-leaveApplication") ||
			hasPermission("readAll-leaveApplication") ||
			hasPermission("readSingle-leaveApplication"))) && {
			label: (
				<span className={styles.menuLabel}>LEAVE</span>
			),
			key: "leave",
			icon: <UserDeleteOutlined />,
			children: [
				hasPermission("create-leaveApplication") && {
					label: (
						<NavLink to='/admin/leave/new' className={styles.menuLabel}>
							<span> New Leave </span>
						</NavLink>
					),
					key: "newLeave",
					icon: <PlusCircleOutlined />,
				},
				hasPermission("readAll-leaveApplication") && {
					label: (
						<NavLink to='/admin/leave' className={styles.menuLabel}>
							<span>Leave Status</span>
						</NavLink>
					),
					key: "leaveStatus",
					icon: <CheckCircleOutlined />,
				},
				hasPermission("readAll-user") && {
					label: (
						<NavLink to='/admin/LeaveContradiction' className={styles.menuLabel}>
							<span>Leave Calendar</span>
						</NavLink>
					),
					key: "Leave Contradiction",
					icon: <CalendarOutlined />,
				},
				hasPermission("readSingle-leaveApplication") && {
					label: (
						<NavLink to={`/admin/leave/user/${user}`} className={styles.menuLabel}>
							<span>My Leaves</span>
						</NavLink>
					),
					key: "myLeaves",
					icon: <FolderOpenOutlined />,
				},
				hasPermission("readAll-designation") && {
					label: (
						<NavLink to='/admin/allocationLeave' className={styles.menuLabel}>
							<span>Leave Allocation</span>
						</NavLink>
					),
					key: "leaveAllocation",
					icon: <SolutionOutlined />,
				},
			],
		},

		(isOnboardingComplete && (hasPermission("create-leaveApplication") ||
			hasPermission("readAll-leaveApplication") ||
			hasPermission("readSingle-leaveApplication"))) && {
			label: (
				<span className={styles.menuLabel}>Advance</span>
			),
			key: "loan",
			icon: <UnlockOutlined />,
			children: [
				hasPermission("create-leaveApplication") && {
					label: (
						<NavLink to='/admin/loan/apply' className={styles.menuLabel}>
							<span> Advance</span>
						</NavLink>
					),
					key: "applyLoan",
					icon: <PlusCircleOutlined />,
				},
				hasPermission("readSingle-leaveApplication") && {
					label: (
						<NavLink to='/admin/loan/status' className={styles.menuLabel}>
							<span>Advance Status</span>
						</NavLink>
					),
					key: "loanStatus",
					icon: <CheckCircleOutlined />,
				},
				hasPermission("readAll-user") && {
					label: (
						<NavLink to='/admin/loan/manage' className={styles.menuLabel}>
							<span>Manage Advance</span>
						</NavLink>
					),
					key: "manageLoans",
					icon: <SettingOutlined />,
				},
			],
		},


		// (isOnboardingComplete && (hasPermission("create-role"))) && {
		// 	label: (
		// 		<span className={styles.menuLabel}>PROJECT</span>
		// 	),
		// 	key: "project",
		// 	icon: <ProjectOutlined />,
		// 	children: [
		// 		hasPermission("create-role") && {
		// 			label: (
		// 				<NavLink to='/admin/expenseProject' className={styles.menuLabel}>
		// 					<span>Project</span>
		// 				</NavLink>
		// 			),
		// 			key: "project",
		// 			icon: <ProjectFilled />,
		// 		},
		// 	],
		// },


		(isOnboardingComplete &&(hasPermission("create-leaveApplication") ||
			hasPermission("readAll-leaveApplication") ||
			hasPermission("readSingle-leaveApplication"))) && {
			label: (
				<span className={styles.menuLabel}>EXPENSE</span>
			),
			key: "expense",
			icon: <WalletOutlined />,
			children: [
				hasPermission("create-leaveApplication") && {
					label: (
						<NavLink to='/admin/expense/new' className={styles.menuLabel}>
							<span> New Expense </span>
						</NavLink>
					),
					key: "newExpense",
					icon: <CreditCardOutlined />,
				},
				hasPermission("readAll-leaveApplication") && {
					label: (
						<NavLink to='/admin/expense' className={styles.menuLabel}>
							<span>Expense Status</span>
						</NavLink>
					),
					key: "expenseStatus",
					icon: <PieChartOutlined />,
				},
				hasPermission("readSingle-leaveApplication") && {
					label: (
						<NavLink to={`/admin/expense/user/${user}`} className={styles.menuLabel}>
							<span>My Expenses</span>
						</NavLink>
					),
					key: "myExpenses",
					icon: <TransactionOutlined />,
				},
			],
		},

		// (isOnboardingComplete && (hasPermission("create-leaveApplication") ||
		// 	hasPermission("readAll-leaveApplication") ||
		// 	hasPermission("readSingle-leaveApplication"))) && {
		// 	label: (
		// 		<span className={styles.menuLabel}>ASSETS</span>
		// 	),
		// 	key: "assets",
		// 	icon: <DatabaseOutlined />,
		// 	children: [
		// 		hasPermission("create-leaveApplication") && {
		// 			label: (
		// 				<NavLink to='/admin/assets' className={styles.menuLabel}>
		// 					<span> New Assets </span>
		// 				</NavLink>
		// 			),
		// 			key: "newAssets",
		// 			icon: <AppstoreAddOutlined />,
		// 		},

		// 		hasPermission("create-leaveApplication") && {
		// 			label: (
		// 				<NavLink to='/admin/assetsStatus' className={styles.menuLabel}>
		// 					<span>Assets Status </span>
		// 				</NavLink>
		// 			),
		// 			key: "newAssets",
		// 			icon: <InboxOutlined />,
		// 		},

		// 		hasPermission("readSingle-leaveApplication") && {
		// 			label: (
		// 				<NavLink to={`/admin/assets/${user}`} className={styles.menuLabel}>
		// 					<span>My Assets</span>
		// 				</NavLink>
		// 			),
		// 			key: "myAssets",
		// 			icon: <SafetyOutlined />,
		// 		},

		// 	],
		// },




		(isOnboardingComplete && hasPermission("readAll-announcement")) && {
			label: (
				<span className={styles.menuLabel}>ANNOUNCEMENT</span>
			),
			key: "announcement",
			icon: <NotificationFilled />,
			children: [
				hasPermission("readAll-announcement") && {
					label: (
						<NavLink to='/admin/announcement' className={styles.menuLabel}>
							<span>Announcement</span>
						</NavLink>
					),
					key: "newLeave",
					icon: <FlagFilled />,
				},
			],
		},



		// (hasPermission("readAll-account") ||
		// 	hasPermission("readAll-transaction") ||
		// 	hasPermission("create-transaction")) && {
		// 		label: (
		// 			<span className={styles.menuLabel}>ACCOUNTS</span>
		// 		),
		// 	key: "accounts",
		// 	icon: <WalletOutlined />,
		// 	children: [
		// 		hasPermission("readAll-account") && {
		// 			label: (
		// 				<NavLink to='/admin/account/' className={styles.menuLabel}>
		// 					<span>Account</span>
		// 				</NavLink>
		// 			),
		// 			key: "accountList",
		// 			icon: <UnorderedListOutlined />,
		// 		},
		// 		hasPermission("create-transaction") && {
		// 			label: (
		// 				<NavLink to='/admin/transaction/create' className={styles.menuLabel}>
		// 					<span>New Transaction</span>
		// 				</NavLink>
		// 			),
		// 			key: "newTransaction",
		// 			icon: <CheckOutlined />,
		// 		},
		// 		hasPermission("readAll-transaction") && {
		// 			label: (
		// 				<NavLink to='/admin/transaction/' className={styles.menuLabel}>
		// 					<span>Transaction List</span>
		// 				</NavLink>
		// 			),
		// 			key: "transactionList",
		// 			icon: <UnorderedListOutlined />,
		// 		},
		// 	],
		// },

		// hasPermission("readAll-account") && {
		// 	label: (
		// 		<span className={styles.menuLabel}>FINANCE REPORT</span>
		// 	),
		// 	key: "report",
		// 	icon: <FlagOutlined />,
		// 	children: [
		// 		hasPermission("readAll-account") && {
		// 			label: (
		// 				<NavLink to='/admin/account/trial-balance' className={styles.menuLabel}>
		// 					<span>Trial Balance</span>
		// 				</NavLink>
		// 			),
		// 			key: "trialBalance",
		// 			icon: <FileDoneOutlined />,
		// 		},
		// 		hasPermission("readAll-account") && {
		// 			label: (
		// 				<NavLink to='/admin/account/balance-sheet' className={styles.menuLabel}>
		// 					<span>Balance Sheet</span>
		// 				</NavLink>
		// 			),
		// 			key: "balanceSheet",
		// 			icon: <FileOutlined />,
		// 		},
		// 		hasPermission("readAll-account") && {
		// 			label: (
		// 				<NavLink to='/admin/account/income' className={styles.menuLabel}>
		// 					<span>Income Statement</span>
		// 				</NavLink>
		// 			),
		// 			key: "incomeStatement",
		// 			icon: <FileSyncOutlined />,
		// 		},
		// 	],
		// },

		(isOnboardingComplete && (hasPermission("crate-award") || hasPermission("readAll-award"))) && {
			label: "AWARDS",
			key: "award",
			icon: <TrophyFilled />,
			children: [
				hasPermission("create-award") && {
					label: (
						<NavLink to='/admin/award/new' className={styles.menuLabel}>
							<span>New Award</span>
						</NavLink>
					),
					key: "newAward",
					icon: <TrophyFilled />,
				},

				hasPermission("readAll-award") && {
					label: (
						<NavLink to='/admin/award' className={styles.menuLabel}>
							<span>Award</span>
						</NavLink>
					),
					key: "award",
					icon: <TrophyFilled />,
				},
			],
		},

		// isOnboardingComplete &&{
		// 	label: (
		// 		<NavLink to='/admin/MyTask' className={styles.menuLabel}>
		// 			<span>My Task</span>
		// 		</NavLink>
		// 	),
		// 	key: "MyTask",
		// 	icon: <CheckCircleOutlined />,
		// },

		// (isOnboardingComplete &&(hasPermission("create-project") ||
		// 	hasPermission("readAll-project") ||
		// 	hasPermission("create-projectTeam") ||
		// 	hasPermission("create-milestone") ||
		// 	hasPermission("readAll-priority") ||
		// 	hasPermission("create-task-Status"))) && {
		// 	label: (
		// 		<span className={styles.menuLabel}>PROJECT</span>
		// 	),
		// 	key: "project",
		// 	icon: <ClusterOutlined />,
		// 	children: [
		// 		hasPermission("create-project") && {
		// 			label: (
		// 				<NavLink to='/admin/project/new' className={styles.menuLabel}>
		// 					<span>Add Project</span>
		// 				</NavLink>
		// 			),
		// 			key: "project",
		// 			icon: <PlusOutlined />,
		// 		},
		// 		hasPermission("readAll-project") && {
		// 			label: (
		// 				<NavLink to='/admin/project' className={styles.menuLabel}>
		// 					<span>All Project</span>
		// 				</NavLink>
		// 			),
		// 			key: "allProject",
		// 			icon: <AppstoreOutlined />,
		// 		},
		// 		hasPermission("create-projectTeam") && {
		// 			label: (
		// 				<NavLink to='/admin/team' className={styles.menuLabel}>
		// 					<span>Team</span>
		// 				</NavLink>
		// 			),
		// 			key: "team",
		// 			icon: <TeamOutlined />,
		// 		},
		// 		(hasPermission("create-priority") ||
		// 			hasPermission("readAll-priority")) && {
		// 			label: (
		// 				<NavLink to='/admin/task-priority' className={styles.menuLabel}>
		// 					<span>Task Priority</span>
		// 				</NavLink>
		// 			),
		// 			key: "taskPriority",
		// 			icon: <StarOutlined />,
		// 		},
		// 		hasPermission("create-milestone") && {
		// 			label: (
		// 				<NavLink to='/admin/milestone' className={styles.menuLabel}>
		// 					<span>Add Milestone</span>
		// 				</NavLink>
		// 			),
		// 			key: "milestone",
		// 			icon: <AimOutlined />,
		// 		},

		// 		hasPermission("create-taskStatus") && {
		// 			label: (
		// 				<NavLink to='/admin/task-status' className={styles.menuLabel}>
		// 					<span>Add Task Status</span>
		// 				</NavLink>
		// 			),
		// 			key: "taskStatus",
		// 			icon: <EditOutlined />,
		// 		},
		// 	],
		// },

// uncomment it to show documents

		(isOnboardingComplete && (hasPermission("readAll-publicHoliday"))) && {
			label: (
				<span className={styles.menuLabel}>DOCUMENTS</span>
			),
			key: "Documents",
			icon: <FileOutlined />,

			children: [
				// hasPermission("create-user") && {
				// 	label: (
				// 		<NavLink to='/admin/documents' className={styles.menuLabel}>
				// 			<span>Add Document</span>
				// 		</NavLink>
				// 	),

				// 	key: "AddDocuments",
				// 	icon: <FileAddOutlined />,
				// },

				// hasPermission("create-user") && {
				// 	label: (
				// 		<NavLink to='/admin/DocumentList' className={styles.menuLabel}>
				// 			<span>Document List</span>
				// 		</NavLink>
				// 	),

				// 	key: "DocumentList",
				// 	icon: <FileTextOutlined />,
				// },

				hasPermission("readAll-publicHoliday") && {
					label: (
						<NavLink to='/admin/FolderManager' className={styles.menuLabel}>
							<span>Document List</span>
						</NavLink>
					),

					key: "FolderManager",
					icon: <FileTextOutlined />,
				},

			],
		},

		
		hasPermission("readAll-setting") && {
			label: (
				<span className={styles.menuLabel}>SETTINGS</span>
			),
			key: "settings",
			icon: <SettingOutlined />,
			style: { marginBottom: "16px" },
			children: [

				hasPermission("readAll-setting") && {
					label: (
						<span className={styles.menuLabel}>Setup</span>
					),
					key: "Setup",
					icon: <SettingOutlined />,
					children: [
						hasPermission("readAll-setting") && {
							label: (
								<Tooltip title="Company Settings">
								<NavLink to='/admin/company-setting' className={styles.menuLabel}>
									<span>Company</span>
								</NavLink>
								</Tooltip>
							),
							key: "invoiceSetting",
							icon: <SettingOutlined />,
						},
						hasPermission("readAll-role") && {
							label: (
								<Tooltip title="Role & Permissions">
								<NavLink to='/admin/role' className={styles.menuLabel}>
									<span>Role</span>
								</NavLink>
								</Tooltip>
							),
							key: "roleAndPermissions",
							icon: <UserSwitchOutlined />,
						},
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/department' className={styles.menuLabel}>
									<span>Department</span>
								</NavLink>
							),
							key: "department",
							icon: <UserSwitchOutlined />,
						},
						hasPermission("readAll-designation") && {
							label: (
								<NavLink to='/admin/designation/' className={styles.menuLabel}>
									<span>Designation</span>
								</NavLink>
							),
							key: "designation",
							icon: <UserSwitchOutlined />,
						},
						hasPermission("readAll-shift") && {
							label: (
								<NavLink to='/admin/shift' className={styles.menuLabel}>
									<span>Shift</span>
								</NavLink>
							),
							key: "newShift",
							icon: <FileDoneOutlined />,
						},

						// hasPermission("readAll-shift") && {
						// 	label: (
						// 		<NavLink to='/admin/dayPartSchedule' className={styles.menuLabel}>
						// 			<span>Day Part Schedule</span>
						// 		</NavLink>
						// 	),
						// 	key: "DayPartSchedule",
						// 	icon: <FileDoneOutlined />,
						// },

						hasPermission("readAll-employmentStatus") && {
							label: (
								<NavLink to='/admin/employment-status' className={styles.menuLabel}>
									<span>Employement Status</span>
								</NavLink>
							),
							key: "employementStatus",
							icon: <FileDoneOutlined />,
						},

						hasPermission("readAll-weeklyHoliday") && {
							label: (
								<NavLink to='/admin/holiday/week' className={styles.menuLabel}>
									<span>Weekly Off</span>
								</NavLink>
							),
							key: "weeklyHoliday",
							icon: <ScheduleOutlined />,
						},
						hasPermission("readAll-publicHoliday") && {
							label: (
								<NavLink to='/admin/holiday/public' className={styles.menuLabel}>
									<span>Public Holiday</span>
								</NavLink>
							),
							key: "publicHoliday",
							icon: <FlagOutlined />,
						},

						hasPermission("readAll-leavePolicy") && {
							label: (
								<NavLink to='/admin/leave-policy' className={styles.menuLabel}>
									<span>Leave Policy</span>
								</NavLink>
							),
							key: "leavePolicy",
							icon: <FileProtectOutlined />,
						},
						hasPermission("readAll-leavePolicy") && {
							label: (
								<Tooltip title="Email Configuration">
								<NavLink to='/admin/emailConfig' className={styles.menuLabel}>
									<span>Email</span>
								</NavLink>
								</Tooltip>
							),
							key: "emailConfig",
							icon: <FileProtectOutlined />,
						},
					]
				},
				(isOnboardingComplete && (
					hasPermission("create-user") ||
					hasPermission("readAll-user") ||
					hasPermission("readAll-role") ||
					hasPermission("readAll-designation") ||
					hasPermission("readAll-department"))) && {
					label: (
						<span className={styles.menuLabel}>Masters</span>
					),
					key: "masters",
					icon: <UserOutlined />,
					children: [
						// hasPermission("create-user") && {
						// 	label: (
						// 		<NavLink to='/admin/category' className={styles.menuLabel}>
						// 			<span>Category</span>
						// 		</NavLink>
						// 	),

						// 	key: "category",
						// 	icon: <AppstoreAddOutlined />,
						// },
						// hasPermission("readAll-user") && {
						// 	label: (
						// 		<NavLink to='/admin/subCategory' className={styles.menuLabel}>
						// 			<span>Sub-Category</span>
						// 		</NavLink>
						// 	),
						// 	key: "subCategory",
						// 	icon: <BranchesOutlined />,
						// },

						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/state' className={styles.menuLabel}>
						// 			<span>City</span>
						// 		</NavLink>
						// 	),
						// 	key: "state",
						// 	icon: <EnvironmentOutlined />,
						// },
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/country' className={styles.menuLabel}>
						// 			<span>Country</span>
						// 		</NavLink>
						// 	),
						// 	key: "country",
						// 	icon: <GlobalOutlined />,
						// },
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/countryOfIssue' className={styles.menuLabel}>
									<span>Country</span>
								</NavLink>
							),
							key: "countryOfIssue",
							icon: <FlagOutlined />,
						},
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/salutation' className={styles.menuLabel}>
									<span>Title</span>
								</NavLink>
							),
							key: "salutation",
							icon: <SmileOutlined />,
						},
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/gender' className={styles.menuLabel}>
									<span>Gender</span>
								</NavLink>
							),
							key: "gender",
							icon: <ManOutlined />,
						},
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/relationShip' className={styles.menuLabel}>
									<span>Relationship</span>
								</NavLink>
							),
							key: "relationShip",
							icon: <TeamOutlined />,
						},
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/placeOfWork' className={styles.menuLabel}>
									<span>Work Place</span>
								</NavLink>
							),
							key: "placeOfWork",
							icon: <HomeOutlined />,
						},
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/contractType' className={styles.menuLabel}>
						// 			<span>Contract Type</span>
						// 		</NavLink>
						// 	),
						// 	key: "contractType",
						// 	icon: <SolutionOutlined />,
						// },

						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/teamsType' className={styles.menuLabel}>
						// 			<span>Team Type</span>
						// 		</NavLink>
						// 	),
						// 	key: "teamsType",
						// 	icon: <ClusterOutlined />,
						// },
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/documentType' className={styles.menuLabel}>
						// 			<span>Document Type</span>
						// 		</NavLink>
						// 	),
						// 	key: "documentType",
						// 	icon: <FileTextOutlined />,
						// },
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/paymentType' className={styles.menuLabel}>
									<span>Payment Type</span>
								</NavLink>
							),
							key: "paymentType",
							icon: <PoundOutlined />,
						},
						hasPermission("readAll-department") && {
							label: (
								<NavLink to='/admin/noticePeriod' className={styles.menuLabel}>
									<span>Notice Period</span>
								</NavLink>
							),
							key: "noticePeriod",
							icon: <ClockCircleOutlined />,
						},
						hasPermission("readAll-department") && {
							label: (
								<Tooltip title="Termination Reason">
								<NavLink to='/admin/terminationReason' className={styles.menuLabel}>
									<span>Termination</span>
								</NavLink>
								</Tooltip>
							),
							key: "terminationReason",
							icon: <StopOutlined />,
						},
						hasPermission("create-role") && {
							label: (
								<NavLink to='/admin/expenseProject' className={styles.menuLabel}>
									<span>Project</span>
								</NavLink>
							),
							key: "project",
							icon: <ProjectFilled />,
						},
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/approveReason' className={styles.menuLabel}>
						// 			<span>Approve Reason</span>
						// 		</NavLink>
						// 	),
						// 	key: "approveReason",
						// 	icon: <CheckCircleOutlined />,
						// },
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/rejectReason' className={styles.menuLabel}>
						// 			<span>Reject Reason</span>
						// 		</NavLink>
						// 	),
						// 	key: "rejectReason",
						// 	icon: <CloseCircleOutlined />,
						// },
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/currency' className={styles.menuLabel}>
						// 			<span>Currency</span>
						// 		</NavLink>
						// 	),
						// 	key: "currency",
						// 	icon: <EuroOutlined />,
						// },
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/rate' className={styles.menuLabel}>
						// 			<span>Rate</span>
						// 		</NavLink>
						// 	),
						// 	key: "rate",
						// 	icon: <PercentageOutlined />,
						// },
						// hasPermission("readAll-department") && {
						// 	label: (
						// 		<NavLink to='/admin/showPay' className={styles.menuLabel}>
						// 			<span>Pay By</span>
						// 		</NavLink>
						// 	),
						// 	key: "showPay",
						// 	icon: <CreditCardOutlined />,
						// },

						// hasPermission("readAll-user") && {
						// 	label: (
						// 		<NavLink to='/admin/lunchHours' className={styles.menuLabel}>
						// 			<span>Break Hours</span>
						// 		</NavLink>
						// 	),
						// 	key: "lunchHours",
						// 	icon: <CoffeeOutlined />,
						// },

					],
				},

				// hasPermission("readAll-setting") && {
				// 	label: (
				// 		<NavLink to='/admin/office-area' className={styles.menuLabel}>
				// 			<span>Office Area</span>
				// 		</NavLink>
				// 	),
				// 	key: "invoiceSetting",
				// 	icon: <SettingOutlined />,
				// },

				// hasPermission("readAll-setting") && {
				// 	label: (
				// 		<span className={styles.menuLabel}>Salary Settings</span>
				// 	),
				// 	key: "salarySettings",
				// 	icon: <SettingOutlined />,
				// 	children: [
				// 		hasPermission("readAll-setting") && {
				// 			label: (
				// 				<NavLink to='/admin/salary-components' className={styles.menuLabel}>
				// 					<span>Components</span>
				// 				</NavLink>
				// 			),
				// 			key: "salaryComponents",
				// 			icon: <SettingOutlined />,
				// 		},

				// 		// hasPermission("readAll-setting") && {
				// 		// 	label: (
				// 		// 		<NavLink to='/admin/salary-templates' className={styles.menuLabel}>
				// 		// 			<span>Templates</span>
				// 		// 		</NavLink>
				// 		// 	),
				// 		// 	key: "salaryTemplates",
				// 		// 	icon: <SettingOutlined />,
				// 		// }
				// 	]
				// },


			],
		},
	];

	return (
		<div>
			<Menu
				theme='dark'
				mode='inline'
				items={menu}
				className='sidenav-menu '
			// openKeys={[sideNavOpenKeys]}
			// style={{ backgroundColor: "transparent" }}
			/>
		</div>
	);
};

export default Sidenav;
